import { Error as FeedbacksError } from '@organisms/Feedbacks';
import React from 'react';
import styled from 'styled-components';

const Error = () => {
    return (
        <ErrorWithStyled>
            <FeedbacksError />
        </ErrorWithStyled>
    );
};
const ErrorWithStyled = styled.span`
    color: #dc3545;
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    height: 32px;
    text-align: left;
    margin-top: 18px;
    position: relative;
    top: 3px;
`

export default Error;